var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79688 11.9997C4.79688 15.9725 8.02833 19.2039 12.0011 19.2039C15.9739 19.2039 19.2054 15.9725 19.2054 11.9997C19.2054 8.02686 15.9739 4.79541 12.0011 4.79541C8.02833 4.79541 4.79688 8.02686 4.79688 11.9997Z",
    fill: "white",
    stroke: "#1D719F",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9176 24H4.08191C1.83108 24 0 22.1684 0 19.9176V10.636C0 10.4778 0.128606 10.3492 0.286853 10.3492C0.4451 10.3492 0.573705 10.4778 0.573705 10.636V19.9176C0.573705 21.8524 2.14757 23.4263 4.08191 23.4263H19.9176C21.8524 23.4263 23.4263 21.8524 23.4263 19.9176V4.08191C23.4263 2.14757 21.8524 0.573705 19.9176 0.573705H4.08191C2.14757 0.573705 0.573705 2.14757 0.573705 4.08191V8.39857C0.573705 8.55681 0.4451 8.68542 0.286853 8.68542C0.128606 8.68542 0 8.55681 0 8.39857V4.08191C0 1.83108 1.83108 0 4.08191 0H19.9176C22.1684 0 24 1.83108 24 4.08191V19.9176C24 22.1684 22.1684 24 19.9176 24Z",
    fill: "#1D719F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.286853 10.0191C0.128606 10.0191 0 9.89052 0 9.73227V9.30199C0 9.14374 0.128606 9.01514 0.286853 9.01514C0.4451 9.01514 0.573705 9.14374 0.573705 9.30199V9.73227C0.573705 9.89052 0.4451 10.0191 0.286853 10.0191Z",
    fill: "#1D719F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 14.5161C15.4254 14.5161 15.3719 14.5013 15.3241 14.4707L11.8484 12.2414C11.7662 12.1888 11.7164 12.0974 11.7164 11.9999V8.09203C11.7164 7.93378 11.845 7.80518 12.0033 7.80518C12.1615 7.80518 12.2901 7.93378 12.2901 8.09203V11.8431L15.6339 13.9878C15.7673 14.0734 15.806 14.2508 15.7204 14.3841C15.6654 14.4697 15.5732 14.5161 15.4785 14.5161Z",
    fill: "#1D719F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBox);
export default __webpack_public_path__ + "static/media/clock-box.e2ab0a0a6e1d0da7329f8d59ed3063e3.svg";
export { ForwardRef as ReactComponent };